jQuery(function ($) {
  "use strict";

  /* ===============================
     ナビゲーション
  =============================== */
  const $trigger = $(".l-header__drawer-trigger");
  const $drawerPanel = $(".l-header__drawer-panel");
  const $overlay = $(".l-header__overlay");
  const $navSp = $(".l-header__nav-sp");
  const $triggerText = $(".l-header__drawer-trigger-text");
  const $reserve = $(".c-fixed-reserve");
  const $drawer = $(".l-header__drawer");

  let lastScrollTop = 0;
  let scrollTimeout;

  let focusableElements = [];
  let firstFocusable = null;
  let lastFocusable = null;

  function setFocusTrap() {
    focusableElements = $drawerPanel
      .find('a[href], button, [tabindex]:not([tabindex="-1"])')
      .add($trigger)
      .filter(":visible")
      .toArray();
    firstFocusable = focusableElements[0];
    lastFocusable = focusableElements[focusableElements.length - 1];
  }

  function openDrawer() {
    $trigger.addClass("active");
    $drawer.addClass("is-open"); // ←ここに付ける
    $overlay.addClass("is-active");

    $drawerPanel.css({ visibility: "visible", opacity: 1 });
    requestAnimationFrame(() => $drawerPanel.addClass("is-open"));

    $triggerText.text("CLOSE");
    $trigger.attr("aria-label", "ナビゲーションメニューを閉じる");

    setFocusTrap();
  }

  function closeDrawer() {
    $trigger.removeClass("active").blur();
    $drawer.removeClass("is-open");
    $overlay.removeClass("is-active");
    $drawerPanel.removeClass("is-open");

    $triggerText.text("MENU");
    $trigger.attr("aria-label", "ナビゲーションメニューを開く");

    setTimeout(() => {
      $drawerPanel.css({ visibility: "", opacity: "" });
    }, 300);
  }

  $(document).on("keydown", function (e) {
    if (!$drawerPanel.hasClass("is-open")) return;
    if (e.key === "Escape") {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key === "Tab" && focusableElements.length) {
      const focused = document.activeElement;
      if (e.shiftKey && focused === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && focused === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  });

  $trigger.on("click", function () {
    $drawerPanel.hasClass("is-open") ? closeDrawer() : openDrawer();
  });

  $drawerPanel.find("a").on("click", function (event) {
    const href = $(this).attr("href");
    const target = $(this).attr("target");
    if (!href || href === "#" || href.startsWith("javascript:")) return;
    if (target === "_blank") {
      closeDrawer();
      return;
    }
    event.preventDefault();

    closeDrawer();

    setTimeout(() => {
      window.location.href = href;
    }, 150);
  });

  $overlay.on("click", closeDrawer);

  /* ===============================
     SPアコーディオン
  =============================== */
  function initExclusiveSpAccordion() {
    if (window.innerWidth > 767) return;

    $(".l-header__accordion-trigger")
      .off("click.spAccordion")
      .on("click.spAccordion", function () {
        const $btn = $(this);
        const targetId = $btn.attr("aria-controls");
        const $content = $("#" + targetId);
        const isOpen = $btn.attr("aria-expanded") === "true";

        $(".l-header__accordion-trigger")
          .not($btn)
          .attr("aria-expanded", "false");
        $(".js-accordion-content").not($content).removeClass("is-open");

        $btn.attr("aria-expanded", !isOpen);
        $content.toggleClass("is-open", !isOpen);
      });

    const currentPath = window.location.pathname;
    $(".js-accordion-content").each(function () {
      const $content = $(this);
      const hasCurrentLink = $content
        .find("a[href]")
        .toArray()
        .some(function (el) {
          return currentPath.includes(
            $(el)
              .attr("href")
              .replace(/^.*\/\/[^\/]+/, ""),
          );
        });
      if (hasCurrentLink) {
        const triggerId = $content.attr("id");
        const $trigger = $('[aria-controls="' + triggerId + '"]');
        $trigger.attr("aria-expanded", "true");
        $content.addClass("is-open");
      }
    });
  }

  initExclusiveSpAccordion();

  $(window).on("resize", function () {
    initExclusiveSpAccordion();
  });

  /* ===============================
     SP  // WEB予約ボタン
  =============================== */

  $(window).on("scroll", function () {
    $(".l-header__contents").toggleClass("is-fixed", $(this).scrollTop() > 50);

    if (window.innerWidth <= 767) {
      $reserve.addClass("is-visible");
    } else {
      $reserve.removeClass("is-visible");
    }

    toggleTopBtn();
  });

  /* ===============================
     ページトップ
  =============================== */

  const topBtnWrapper = $(".page-top");
  const topBtn = $(".page-top a");

  topBtnWrapper.hide();
  topBtn.attr("tabindex", "-1");

  function toggleTopBtn() {
    if ($(window).scrollTop() > 650) {
      if (!topBtnWrapper.is(":visible")) {
        topBtnWrapper.fadeIn(300, function () {
          topBtn.attr("tabindex", "0");
        });
      }
    } else {
      topBtn.attr("tabindex", "-1");
      topBtnWrapper.fadeOut(300);
    }
  }

  topBtn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  /* ===============================
     スムーススクロール
  =============================== */

  const speed = 1500;

  function getHeaderHeight() {
    return ($(".l-header").outerHeight() || 0) + 45;
  }

  function scrollToTarget($target) {
    const position = $target.offset().top - getHeaderHeight();
    $("html, body").stop().animate({ scrollTop: position }, speed);
  }

  $('a[href^="#"]').on("click", function (e) {
    const href = $(this).attr("href");
    const $target = href === "#" ? $("html") : $(href);

    if ($target.length) {
      e.preventDefault();
      scrollToTarget($target);
      history.pushState(null, null, href);
    }
  });

  $(window).on("load", function () {
    const hash = window.location.hash;
    if (hash) {
      const $target = $(hash);
      if ($target.length) scrollToTarget($target);
    }
  });
});
